import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MaterialModule } from '@app/material/material.module';

import { DataGridModule } from '@shared/components/data-grid/data-grid.module';

import { SelectModule } from '@shared/components/form/select/select.module';
import { InputModule } from '@shared/components/form/input/input.module';
import { ButtonModule } from '@shared/components/button/button.module';

import { SectorPipe } from '@shared/pipes/sector.pipe';

import { AnswerSetAddQuestionDialogComponent } from './answer-set-add-question-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    SelectModule,
    InputModule,
    ButtonModule,
    FormsModule,
    DataGridModule,
    ReactiveFormsModule
  ],
  providers: [SectorPipe],
  declarations: [AnswerSetAddQuestionDialogComponent],
  entryComponents: [AnswerSetAddQuestionDialogComponent],
  exports: [AnswerSetAddQuestionDialogComponent]
})
export class AnswerSetAddQuestionDialogModule { }
